import _Vue from 'vue'
import Axios from 'axios'

export function AxiosPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$http = Axios
}
